/** Deep camelCase keys so scheduled-event JSON matches root-api REST transforms. */
const snakeToCamelKey = (key: string) => key.replace(/_([a-z0-9])/gi, (_, char: string) => char.toUpperCase())

const camelCaseKeysDeep = (value: unknown): Record<string, unknown> | unknown[] | unknown => {
  if (Array.isArray(value)) {
    return value.map(camelCaseKeysDeep)
  }
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, nested]) => [
        snakeToCamelKey(key),
        camelCaseKeysDeep(nested),
      ]),
    )
  }
  return value
}

/** `getScheduledEvent.event` is monolith scheduled-events JSON (same as REST GET). */
export const transformGetScheduledEventSupergraphResponse = (
  response: any,
): Record<string, unknown> | null => {
  const event = response?.getScheduledEvent?.event
  if (event == null || typeof event !== 'object') return null
  return camelCaseKeysDeep(event) as Record<string, unknown>
}
